import axios from 'axios'
import baseStore from '../../index'

const state = {
  contactItems: (localStorage.getItem("contactsList")) ? JSON.parse(localStorage.getItem('contactsList')) : [],
  user: (localStorage.getItem("user")) ? JSON.parse(localStorage.getItem('user')) : null
}

const mutations = {
  UPDATE_USER(state, playload) {
    if (playload) {
      state.user = playload;
      //console.log('userId: '+ state.user.id +' userLevel: '+ state.user.level +' userEmail: '+ state.user.email);
      //console.log('Updated user: ', state.user)
    }
  },
  UPDATE_CONTACT_LIST (state, playload) {
    state.contactItems = playload;
    //console.log(state.contactItems)
    //console.log('UPDATE_CONTACT_LIST');
  },
}

const actions = {
  async getContactItems ({ commit, dispatch }, token) {
    console.log('getContactItems => offline: '+ baseStore.getters.offlineMode)
    if (baseStore.getters.offlineMode) {
      const contacts = JSON.parse(localStorage.getItem('contactsList'))
      commit('UPDATE_CONTACT_LIST', contacts)
      dispatch('getProfile')
    } else {
      return axios
      .get(baseStore.getters.apiPath +'contacts', {
          headers: {
            'Authorization': `JWT ${token}` 
          }
        }
      )
      .then((response) => {
        //console.log(response.data);
        if (response.data.error) {
          global.showError(response.data.error, response.data.login)
        } else {
          commit('UPDATE_CONTACT_LIST', response.data);
          localStorage.setItem('contactsList', JSON.stringify(response.data))
          dispatch('getProfile')
        }
      })
      .catch((error) => {
        global.showError(error)
        console.log("GET call unsuccessful :(", error);
      });
    }
  },
  getProfile ({ commit }) {
    const userEmail = localStorage.getItem("userEmail");
    console.log('getProfile => email '+ userEmail)
    if (!userEmail) return false
		if (!state.contactItems) {
			let admin
			if (userEmail == "barbara@ilvideo.com") {
				admin = { id: 1, levelId: 1, surname: "Longhi", name: "Barbara", email: "barbara@ilvideo.com", confirmed: 1}
				commit('UPDATE_USER', admin);
				return
			} else if (userEmail == "sergio.beneventi@coesia.com") {
				admin = { id: 1, levelId: 2, surname: "Beneventi", name: "Sergio", email: "sergio.beneventi@coesia.com", confirmed: 1}
				commit('UPDATE_USER', admin);
				return
			} else {
				return null;
			}
		}
    let user = state.contactItems.find(
      (contactItem) => contactItem.email.toLowerCase() === userEmail.toLowerCase()
    )
    if (user) {
      //console.log('Update user: ', user)
      commit('UPDATE_USER', user);
      localStorage.setItem('user', JSON.stringify(user))
      //if (user.id === 1) dispatch('testing')
    }
  },
  saveProfileInfo({ commit }, contactItem) {
    const token = localStorage.getItem("token");
    axios
      .post(baseStore.getters.apiPath +'profile/info', contactItem, {
          headers: {
            'Authorization': `JWT ${token}` 
          }
        }
      )
      .then((response) => {
        if (response.data.error) {
          global.showError(response.data.error, response.data.login)
        } else {
          commit('UPDATE_CONTACT_LIST', response.data);
        }
      })
      .catch((error) => {
        global.showError(error)
        console.log("POST call unsuccessful :(", error);
    });
  },
  saveProfileImage({ commit }, contactItem) {
    const token = localStorage.getItem("token");
    axios
      .post(baseStore.getters.apiPath +'profile/image', contactItem, {
          headers: {
            'Authorization': `JWT ${token}` 
          }
        }
      )
      .then((response) => {
        if (response.data.error) {
          global.showError(response.data.error, response.data.login)
        } else {
          commit('UPDATE_CONTACT_LIST', response.data);
        }
      })
      .catch((error) => {
        global.showError(error)
        console.log("POST call unsuccessful :(", error);
    });
  },
  saveDateInfo({ commit, dispatch }, contactItem) {
    const token = localStorage.getItem("token");
    axios
      .post(baseStore.getters.apiPath +'profile/date', contactItem, {
          headers: {
            'Authorization': `JWT ${token}`
          }
        }
      )
      .then((response) => {
        if (response.data.error) {
          global.showError(response.data.error, response.data.login)
        } else {
          commit('UPDATE_CONTACT_LIST', response.data);
          dispatch('getProfile')
					return true
        }
        //commit('UPDATE_USER', contactItem)
      })
      .catch((error) => {
        global.showError(error)
        console.log("POST call unsuccessful :(", error);
    });
  },
  updateTourRequest({ commit }, contacts) {
		commit('UPDATE_CONTACT_LIST', contacts);
  },
  saveBookingRequest({ commit }, contactItem) {
    const token = localStorage.getItem("token");
    axios
      .post(baseStore.getters.apiPath +'partecipate', contactItem, {
          headers: {
            'Authorization': `JWT ${token}` 
          }
        }
      )
      .then((response) => {
        if (response.data.error) {
          //global.showError(response.data.error, response.data.login)
					return response.data.error
        } else {
          commit('UPDATE_CONTACT_LIST', response.data);
					return true
        }
        //commit('UPDATE_USER', contactItem)
      })
      .catch((error) => {
        global.showError(error)
        console.log("POST call unsuccessful :(", error);
    });
  },
  removeBookingRequest({ commit }, contactItem) {
    const token = localStorage.getItem("token");
    axios
      .post(baseStore.getters.apiPath +'delpartecipate', contactItem, {
          headers: {
            'Authorization': `JWT ${token}` 
          }
        }
      )
      .then((response) => {
        if (response.data.error) {
          global.showError(response.data.error, response.data.login)
        } else {
          commit('UPDATE_CONTACT_LIST', response.data);
					return true
        }
        //commit('UPDATE_USER', contactItem)
      })
      .catch((error) => {
        global.showError(error)
        console.log("POST call unsuccessful :(", error);
    });
  }
}

const getters = {
  contactItems: state => state.contactItems,
  contactItemFromId: (state) => (userId) => {
		if (!state.contactItems) return null;
    return state.contactItems.find(contactItem => contactItem.id === Number(userId))
  },
  contactItemFromType: (state) => (fairId, type) => {
    //console.log('contactItemFromType: '+ type +' fairId: '+ fairId)
    let allItems = state.contactItems;
    let contactItems = [];
    allItems.forEach(function(contact) {
      if (type === 'participants' && contact.participants) {
        let participant = contact.participants.find(userItem => userItem.fairId === Number(fairId))
        if (participant) contactItems.push(contact)
      }
      if (type === 'staff' && contact.staff) {
        let staff = contact.staff.find(userItem => userItem.fairId === Number(fairId))
        if (staff) {
					contact.position = staff.position
					contactItems.push(contact)
				}
      }
    });
		if (type === 'staff') {
			contactItems.sort((a, b) => a.position - b.position)
		}
    //console.log(contactItems)
    return contactItems;
  },
  contactType: (state) => (fairId, userId) => {
		/* if (!state.contactItems) return null;
		let userItem = state.contactItems.find(userItem => (userItem.id === Number(userId))); */
		if (!state.contactItems || !state.user) return null;
		let userItem = state.user
    //console.log('userItem', userItem)
		if (!userItem) return null;
		console.log("=> getContactType - fairId: "+ fairId +" user: "+ userId +" level: "+ userItem.level)
		//console.log('contactItem',  userItem)
		let userState
		if (userItem.participants) {
			userState = userItem.participants.find(userState => userState.fairId === Number(fairId))
			if (userState) {
				userState.isparticipant = true
				userState.authorized = true
			}
		}
		if (!userState && userItem.staff) {
			userState = userItem.staff.find(userState => userState.fairId === Number(fairId))
			if (userState) {
				userState.isstaff = true
				userState.authorized = true
			}
		}
		if (!userState && userItem.visitors) {
			userState = userItem.visitors.find(userState => userState.fairId === Number(fairId))
			if (userState) {
				userState.isvisitor = true
				userState.authorized = true
			}
		}
		// admin level
		if (!userState && userItem.level !== 'user') {
			userState = userItem
		}
    if (userState && userItem.level !== 'user') {
        userState.isadmin = true
        userState.authorized = true
    }
		//console.log('userState', userState)
		return userState
  },
  contactItemFromLogin: (state) => (userName, userEmail) => {
    let userObj = { title: userName, email: userEmail, level: state.userLevel }
    return userObj
  },
  user: state => state.user
}

const contactsModule = {
  state,
  mutations,
  actions,
  getters,
}

export default contactsModule
